import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import './styles.css';

/**
 * SPA entrypoint. Wires the two app-level providers around the §10 route table:
 *   - QueryClientProvider — server state (ARCHITECTURE_PLAN §1.2 react-query);
 *   - BrowserRouter       — clean URLs; the Worker's static-assets binding
 *     serves index.html for unknown navigation paths (wrangler.jsonc SPA mode).
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  // Fail loud: the HTML shell must contain #root. No silent no-op.
  throw new Error('Root element #root not found in document');
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>
);
